import { css } from "@emotion/css";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

import { fadeIn } from "../../core/styles/Animation";

export const buttonOffset = css`
    margin-left: ${Spacing.SM}px;
`;

export const sectionNavigationContainer = css`
    padding-top: 32px;
    ${fadeIn}
`;

export const sectionTitleStyle = css`
    ${Fonts.Heading.H300};
    overflow: hidden;
    max-width: 500px;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const sectionSubtitleStyle = css`
    ${Fonts.Heading.H500};
    padding-right: 20px;
    color: ${Colors.Gray.V300};
`;

export const groupDescriptionCss = css`
    ${Fonts.Paragraph.P200};
    min-height: 45px;
    margin-bottom: 5px;
`;
